import * as deepmerge from "deepmerge";
import {
  codigoPaquete /*codigosTarjetas*/,
  garantiaLimite
} from "@/config/constantes/paquetes";

const direccion =
  "Dirección: Av. Córdoba 111 Piso 31, CABA <br/> Teléfono: 0800-333-0303<br/>  CUIT: 30-50000319-3";

const footer_text =
  `Los depósitos en pesos y en moneda extranjera cuentan con la garantía de hasta $ ${garantiaLimite}. En las operaciones a nombre de dos o más personas, la garantía se prorrateará entre sus titulares. En ningún caso, el total de la garantía por persona y por depósito podrá exceder de $ ${garantiaLimite}, cualquiera sea el número de cuentas y/o depósitos. Ley 24.485, Decreto N° 540/95 y modificatorios y Com. "A" 2337 y sus modificatorias y complementarias. Se encuentran excluidos los captados a tasas superiores a la de referencia conforme a los límites establecidos por el Banco Central, los adquiridos por endoso y los efectuados por personas vinculadas a la entidad financiera.`;

const footer = direccion + "<br/><br/>" + footer_text;
/**
 * Configuración default de campaña
 * Será mergeada con deepmerge con campaña específica
 */
export default {
  googleAnalyticsId: "UA-164079212-1",
  modulo: "Plazo Fijo Online",
  ayuda: {
    mostrar: false,
    telefono1: "0810-222-4040",
    telefono2: "4346-4800",
  },
  cantPasos: 6,
  paperless: false,
  pasos: {
    simulacion: {
      path: "/",
      component: "views/Simulacion",
      titulo: "Simulá tu Plazo Fijo en BBVA",
      subtitulo:
        "Ingresá el monto y la cantidad de días para conocer el importe total que recibirás cuando venza el plazo.",
      logoSimulacion: false,
      monto: 100,
      meta: "simulacion",
      pasoSiguiente: "noCliente",
      footerText: footer,
    },
    noCliente: {
      path: "/noCliente",
      component: "views/NoCliente",
      titulo: "Para hacer tu Plazo Fijo Online seguí estos pasos",
      subtitulo: "",
      logoCobranding: false,
      pasoSiguiente: "datosPersonales",
      paso: 3,
      footerText: footer,
    },
    datosPersonales: {
      path: "/datosPersonales",
      component: "views/DatosPersonales",
      titulo: "Datos personales",
      subtitulo:
        "Para poder validar tu identidad te vamos a pedir algunos datos personales.",
      logoCobranding: false,
      pasoSiguiente: "datosLaborales",
      paso: 1,
      footerText: footer,
    },
    datosLaborales: {
      path: "/datosLaborales",
      component: "views/DatosLaborales",
      titulo: "Datos laborales",
      subtitulo:
        "Te pedimos estos datos porque son un requisito normativo para este tipo de operación.",
      logoCobranding: false,
      pasoSiguiente: "activity",
      paso: 2,
      footerText: footer,
    },
    activity: {
      path: "/activity",
      component: "views/Activity",
      titulo: "Información adicional",
      subtitulo:
        "Si nunca escuchaste hablar de estos términos seguramente tus respuestas deberían ser 'No'.",
      logoCobranding: false,
      pasoSiguiente: "datosCuenta",
      paso: 3,
      footerText: footer,
    },
    datosCuenta: {
      path: "/datosCuenta",
      component: "views/DatosCuenta",
      titulo: "Datos de la cuenta",
      subtitulo:
        "Indicanos la cuenta de la que querés debitar el monto, una vez vencido el plazo recibirás en ella el importe debitado más el interés.",
      logoCobranding: false,
      paso: 4,
      pasoSiguiente: "confirmacion",
      footerText: footer,
    },
    confirmacion: {
      path: "/confirmacion",
      component: "views/Confirmacion",
      titulo: "Confirmación",
      subtitulo: "Para finalizar, verificá que todos los datos estén correctos",
      logoCobranding: false,
      paso: 5,
      nombreSiguiente: "Solicitar",
      pasoSiguiente: "verificando",
      footerText: footer,
    },
    verificando: {
      path: "/verificando",
      component: "views/Verificando",
      pasoSiguiente: "thankyou",
      footerText: footer,
    },
    thankyou: {
      path: "/thankyou",
      component: "views/Gracias",
      footerText: footer,
    },
    pepsosi: {
      path: "/pepsosi",
      component: "views/PepSoSi",
      titulo: "",
      subtitulo: "Lo sentimos mucho",
      logoCobranding: false,
      pasoSiguiente: "",
      footerText: footer,
    },
    cuentaBBVA: {
      path: "/cuentaBBVA",
      component: "core/modals/CuentaBBVA",
      titulo: "",
      subtitulo: "",
      logoCobranding: false,
      pasoSiguiente: "",
      footerText: footer,
    },
    mensaje: {
      path: "/mensaje/:mje",
      component: "views/Mensaje",
    },

    errorInesperado: {
      path: "/errorInesperado",
      component: "views/ErrorInesperado",
      titulo: "",
      subtitulo: "Algo salió mal",
      logoCobranding: false,
      pasoSiguiente: "",
      footerText: footer,
    },

    mensajeInvalido: {
      path: "/mensajeInvalido",
      component: "views/Mensaje_1",
      titulo: "",
      subtitulo: "Los Datos de identidad no coinciden",
      logoCobranding: false,
      pasoSiguiente: "",
      footerText: footer,
    },
  },
};

/**
 * Configuración de info de paquete para campaña
 */
export const infoCampania = (paquete /**, beneficiosGlobales */) => {
  // Info de campaña general
  let _infoCampania = {};

  /**
   * Configuración específica para cada paquete
   * La configuración anterior es válida para la campaña actual y TODOS los paquetes
   * En el siguiente puedo sobreescribir configuración específica para cada paquete
   */
  let _paqueteEspeciales = {
    /*Dejar vacío*/
  };
  switch (paquete.tipoPaquete) {
    case codigoPaquete.TARJETA_SUELTA:
    case codigoPaquete.LIBRETON_EXPRESS:
    case codigoPaquete.LIBRETON_FULL:
    case codigoPaquete.LIBRETON_PLUS_GOLD:
    case codigoPaquete.LIBRETON_PREMIUM:
    case codigoPaquete.LIBRETON_PREMIUM_WORLD:
      _paqueteEspeciales = {};
      break;
  }

  /**
   * Configuración específica para cada paquete POR TARJETA (SOLO VALIDO PARA TARJETA SUELTA)
   * La configuración anterior es válida para la campaña actual y TODOS los paquetes
   * En el siguiente puedo sobreescribir configuración específica para cada tarjeta de tarjeta suelta
   * VER EJEMPLOS EN ofertaPeugeot
   */
  let _paqueteEspecialesPorTarjeta = {
    /*Dejar vacío*/
  };

  /**
   * Sobreescribir algunos campos que dependen de la configuración global
   * CUIDADO: No sobreescribir campos de beneficiosGlobales directamente
   * VER EJEMPLO DE USO EN ofertaPeugeot
   */
  let _globalesOverwrite = {
    /* Dejar vacío*/
  };

  // Devolver el objeto mergeado
  const overwriteMerge = (_, sourceArray) => sourceArray;
  return deepmerge.all(
    [
      _infoCampania,
      _paqueteEspeciales,
      _paqueteEspecialesPorTarjeta,
      _globalesOverwrite,
    ],
    { arrayMerge: overwriteMerge }
  );
};

/**
 * Configuración de los nombres de tarjeta
 * (no necesaria, debe exportarse vacía)
 */
export const nombresTarjetas = {};

/**
 * Configuración de los nombres de tarjeta para Adobe Tagging
 * (no necesaria, debe exportarse vacía)
 */
export const nombresTarjetasAdobe = {};
